import { Injectable } from '@angular/core';
import { LogService } from './log.service';
import {
  NgbModal,
  NgbModalOptions,
  NgbModalRef
} from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from './message.service';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private defaultOptions: NgbModalOptions = {
    centered: true,
    keyboard: false,
    backdrop: 'static'
  };
  private isModalOpen = false;
  private modalRef: NgbModalRef;

  constructor(
    private log: LogService,
    private modal: NgbModal,
    private messageService: MessageService
  ) {}

  isOpen(): boolean {
    return this.isModalOpen;
  }

  close() {
    if (this.modalRef != null) {
      this.modalRef.close();
    }
  }

  open(
    content: any,
    options?: NgbModalOptions,
    onAccept?: Function,
    onReject?: Function
  ) {
    if (!options) {
      options = this.defaultOptions;
    }

    this.modalRef = this.modal.open(content, options);

    this.modalRef.result.then(
      result => {
        if (onAccept) {
          onAccept();
        }
        this.onClose();
      },
      reason => {
        if (onReject) {
          onReject();
        }
        this.onClose();
      }
    );

    this.messageService.postModalOpenMessage();
    this.isModalOpen = true;
  }

  private onClose() {
    this.isModalOpen = false;
    this.messageService.postModalCloseMessage();
  }
}
